import { render, staticRenderFns } from "./EditKanbanfunnel.vue?vue&type=template&id=0ab4c39c&scoped=true&"
import script from "./EditKanbanfunnel.vue?vue&type=script&lang=js&"
export * from "./EditKanbanfunnel.vue?vue&type=script&lang=js&"
import style0 from "./EditKanbanfunnel.vue?vue&type=style&index=0&id=0ab4c39c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab4c39c",
  null
  
)

export default component.exports